import FormData from 'form-data';
import HttpStatus from 'http-status-codes';
import { push } from 'react-router-redux';
import { asyncRequest } from './async-request';
import { TOMCAT_URL } from './index';
import { initializeCsrfToken } from 'src/actions/api/csrf';

export const RESET = 'RESET';

export function login(
    username: string,
    password: string,
    onSuccess: any,
    onFailure: any,
    noRedirectOnUnauthenticated: boolean,
    on2fa: any,
) {
    return (dispatch: any) => {
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);

        asyncRequest({
            endpoint: `${TOMCAT_URL}public/login`,
            method: 'POST',
            body: formData,
            noRedirectOnUnauthenticated: noRedirectOnUnauthenticated,
        })
            .then((response: any) => {
                if (response.status === HttpStatus.ACCEPTED) {
                    if (on2fa) on2fa();
                } else {
                    if (onSuccess) dispatch(onSuccess());
                }
            })
            .catch((error: any) => {
                if (onFailure) onFailure(error.status);
                else dispatch(push(`/login?error=${error.status}`));
            });
    };
}

export function verify2fa(code: string, onSuccess: any, onFailure: any) {
    return (dispatch: any) => {
        const formData = new FormData();
        formData.append('code', code);

        return asyncRequest({
            endpoint: `${TOMCAT_URL}public/login-2fa`,
            method: 'POST',
            body: formData,
            noRedirectOnUnauthenticated: true,
        })
            .then((response: any) => {
                if (onSuccess) dispatch(onSuccess());
                return response;
            })
            .catch((error: any) => {
                if (onFailure) onFailure(error.status);
                else dispatch(push(`/login?error=tfa`));
            });
    };
}

export function loginWithToken(token: string, onSuccess: any, onFailure: any, noRedirectOnUnauthenticated: boolean) {
    return (dispatch: any) => {
        asyncRequest({
            endpoint: `${TOMCAT_URL}public/sso/login-with-token`,
            method: 'POST',
            body: {
                token: token,
            },
            noRedirectOnUnauthenticated: noRedirectOnUnauthenticated,
        })
            .then((response: any) => {
                if (onSuccess) dispatch(onSuccess());
            })
            .catch((error: any) => {
                if (onFailure) onFailure(error.status);
                else dispatch(push(`/login-with-token?error=${error.status}`));
            });
    };
}

export function logout() {
    return (dispatch: any) => {
        dispatch(reset())
            .then(dispatch(push(`/login?logout=true`)))
            .then(() => {
                asyncRequest({
                    endpoint: `${TOMCAT_URL}public/logout`,
                    method: 'POST',
                })
                    .then(() => {
                        // Get a new CSRF token after logout
                        initializeCsrfToken().then();
                    })
                    .catch(error => {
                        console.debug('Error on logout', error);
                    });
            });
    };
}

export function reset() {
    return {
        type: RESET,
    };
}
